module.exports = __webpack_public_path__ + "static/media/homepage-overlay-3.8e7169f7.webp";